import {Typography} from 'antd';
import {Ellipsize} from 'components';
import React from 'react';
import {Helmet} from 'react-helmet';
import styled from 'styled-components';
import {SectionProps} from './utils/types';

const Title = styled(Typography.Title)`
  position: relative;
  display: flex;
  overflow: hidden;
  margin: 0;
  align-items: center;
`;

export const AffiliateTitle: React.FC<SectionProps> = ({affiliate}) => {
  if (!affiliate) return null;

  const fullName = [affiliate.firstname, affiliate.lastname].filter(Boolean).join(' ');
  const affiliateName = affiliate.company?.name || fullName || '';

  return (
    <Title>
      <Helmet title={affiliateName} />
      <Ellipsize>{affiliateName}</Ellipsize>
    </Title>
  );
};
